import React from 'react';
import Wrapper from './Wrapper/Wrapper';
import * as classes from './Gallery.module.css';

const Gallery = (props) =>{
    const wrappers = [];

    //Load all the wrappers to prevent flash on active caramel switch
    for (let type in props.caramels){
        let wrapper = <Wrapper {...props.caramels[type]} active={props.active === type}/>
        wrappers.push(wrapper)
    }

    return (
        <div
            className={classes.Gallery}
        >
            {wrappers}
        </div>
    )
};

export default Gallery;